export default __webpack_public_path__ + "static/media/330_dummy-2014-store03-de.fda25df7.png";